import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UsuarioModalComponent } from '../../modals/usuario-modal/usuario-modal.component';
import { Usuario } from '../../../models/usuario';
import { ParametroService } from '../../../services/parametro.service';
import { CajaModalComponent } from '../../modals/caja-modal/caja-modal.component';
import { Caja } from '../../../models/caja';
import { CajeroCajaService } from '../../../services/cajero-caja.service';
import { CajeroCaja } from '../../../models/cajero-caja';
import { SweetMessage } from '../../../config/sweet-message';
import { SessionService } from '../../../services/session.service';

@Component({
	selector: 'cajero-asignar',
	templateUrl: './cajero-asignar-add.component.html',
	styleUrls: ['./cajero-asignar-add.component.css'],
	providers: [ParametroService,CajeroCajaService,SessionService]
})
export class CajeroAsignarAddComponent implements OnInit {
	public bsModalRef: BsModalRef;
	public usuario: Usuario;
	public caja: Caja;
	public msg: SweetMessage;
	public loading = false;

	constructor(
		private modalService: BsModalService,
		public parametroService: ParametroService,
		public cajeroCajaService: CajeroCajaService,
		public ss: SessionService,
	) {
		this.usuario = new Usuario();
		this.caja = new Caja();
		this.msg = new SweetMessage();
	}

	ngOnInit() {
		//
	}

	openDialogCajero() {
		let parametro_perfil_cajero_id = 2;
		this.loading = true;
		this.parametroService.getById(parametro_perfil_cajero_id).subscribe(
			res => {
				this.loading = false;
				let cajero_perfil_id = res.valor;
				const initialState = {qs: "&perfil_id=" + cajero_perfil_id};
				this.bsModalRef = this.modalService.show(UsuarioModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

				this.bsModalRef.content.sendUsuario.take(1).subscribe(usuario => this.usuario = usuario);
			},
			err => {
				this.loading = false;
			}
		);
	}
	
	openDialogCaja() {
		const initialState = {};
		this.bsModalRef = this.modalService.show(CajaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.onSelectItem.take(1).subscribe(caja => this.caja = caja);
	}
	
	onSubmit(){
		let cc = new CajeroCaja();
		cc.cajero_id = this.usuario.id;
		cc.caja_id = this.caja.id;
		cc.usuario_id = this.ss.getData('usuario_id');
		cc.empresa_id = this.ss.getData('empresa_id');
		cc.sucursal_id = this.ss.getData('sucursal_id');

		this.loading = true;
		this.cajeroCajaService.save(cc).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);
				this.caja = new Caja();
				this.usuario = new Usuario();
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message', err);
			}
		);
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/cajero-asignar-add/cajero-asignar-add.component.ts